import { createUseStyles } from 'react-jss'
import { tableStyle } from '../../blocks/table/text-table.style'

export const style = {
  table: {
    ...tableStyle.table,
    margin: '15px auto',
    '& .ql-editor': {
      padding: 0
    }
  },
  resizeGrabber: {
    position: 'absolute',
    top: 0,
    right: -5,
    height: '100%',
    width: 10,
    cursor: 'col-resize',
    zIndex: 1
  }
}

export const useStyles = createUseStyles(style)
